module.exports = __webpack_public_path__ + "img/icons-profile.6d7eac6f.svg";